export const formatDate = (value?: string | null) => {
  if (!value) {
    return '';
  }

  const [year, month, day] = value.split('-');
  if (!year || !month || !day) {
    return '';
  }

  return `${year}년 ${Number(month)}월 ${Number(day)}일`;
};
export const formatAccount = (account?: string | null) => {
  if (!account) {
    return '';
  }

  if (account.length !== 14) {
    return account;
  }

  return `${account.slice(0, 3)}-${account.slice(3, 9)}-${account.slice(9, 11)}-${account.slice(11, 14)}`;
};
export const formatAccountBankNo = (bank?: string | null, accountNo?: string | null) => {
  if (!bank || !accountNo) {
    return '';
  }

  return `${bank} ${accountNo}`;
};
export const shortenBizName = (bizName: string) => {
  const MAX_LENGTH = 10;

  if (bizName.length <= MAX_LENGTH) {
    return bizName;
  }

  return `${bizName.slice(0, MAX_LENGTH)}...`;
};

export const escapeHtml = (value: string): string => {
  return value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
};
